require('./ctxPivotTable.style.scss');
const template = require('./ctxPivotTable.template.html');

class PivotTableController {
    constructor($element, $scope, $filter, $q, $timeout, $compile, utilsService, config) {
        this.$element = $element;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.utilsService = utilsService;
        this.configGeneral = config;
        this.openedDropdown = undefined;

        this.reportTypes = [
            { id: 1, group: 'Tables', label: this.$filter('translate')('ctxPivotTable.reportType.table'), detail: this.$filter('translate')('ctxPivotTable.reportType.table'), value: 'Table' },
            { id: 2, group: 'Tables', label: this.$filter('translate')('ctxPivotTable.reportType.heatmap'), detail: this.$filter('translate')('ctxPivotTable.reportType.heatmap'), value: 'Heatmap' },
            { id: 3, group: 'Tables', label: this.$filter('translate')('ctxPivotTable.reportType.rowHeatmap'), detail: this.$filter('translate')('ctxPivotTable.reportType.rowHeatmap'), value: 'Row Heatmap' },
            { id: 4, group: 'Tables', label: this.$filter('translate')('ctxPivotTable.reportType.colHeatmap'), detail: this.$filter('translate')('ctxPivotTable.reportType.colHeatmap'), value: 'Col Heatmap' },
            { id: 5, group: 'Tables', label: this.$filter('translate')('ctxPivotTable.reportType.tableBarchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.tableBarchart'), value: 'Table Barchart' },
            { id: 6, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.barchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.barchart'), value: 'Bar Chart' },
            { id: 7, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.horizontalBarchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.horizontalBarchart'), value: 'Horizontal Bar Chart' },
            { id: 8, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.stackedBarchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.table'), value: 'Stacked Bar Chart' },
            { id: 9, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.horizontalStackedBarchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.horizontalStackedBarchart'), value: 'Horizontal Stacked Bar Chart' },
            { id: 10, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.linechart'), detail: this.$filter('translate')('ctxPivotTable.reportType.linechart'), value: 'Line Chart' },
            { id: 11, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.areachart'), detail: this.$filter('translate')('ctxPivotTable.reportType.areachart'), value: 'Area Chart' },
            { id: 12, group: 'Charts', label: this.$filter('translate')('ctxPivotTable.reportType.scatterchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.scatterchart'), value: 'Scatter Chart' }
            //{ id: 13, label: this.$filter('translate')('ctxPivotTable.reportType.doughnutchart'), detail: this.$filter('translate')('ctxPivotTable.reportType.doughnutchart'), value: 'Doughnut Chart' }
        ];
        this.reportAggregations = [
            { id: 1, label: this.$filter('translate')('ctxPivotTable.aggregation.none'), detail: this.$filter('translate')('ctxPivotTable.aggregation.none'), value: 'None' },
            { id: 2, label: this.$filter('translate')('ctxPivotTable.aggregation.count'), detail: this.$filter('translate')('ctxPivotTable.aggregation.count'), value: 'Count' },
            { id: 3, label: this.$filter('translate')('ctxPivotTable.aggregation.sum'), detail: this.$filter('translate')('ctxPivotTable.aggregation.sum'), value: 'Sum' },
            { id: 4, label: this.$filter('translate')('ctxPivotTable.aggregation.average'), detail: this.$filter('translate')('ctxPivotTable.aggregation.average'), value: 'Average' },
            { id: 5, label: this.$filter('translate')('ctxPivotTable.aggregation.median'), detail: this.$filter('translate')('ctxPivotTable.aggregation.median'), value: 'Median' },
            { id: 6, label: this.$filter('translate')('ctxPivotTable.aggregation.sampleVariance'), detail: this.$filter('translate')('ctxPivotTable.aggregation.sampleVariance'), value: 'SampleVariance' },
            { id: 7, label: this.$filter('translate')('ctxPivotTable.aggregation.sampleStandardDeviation'), detail: this.$filter('translate')('ctxPivotTable.aggregation.sampleStandardDeviation'), value: 'SampleStandardDeviation' },
            { id: 8, label: this.$filter('translate')('ctxPivotTable.aggregation.minimum'), detail: this.$filter('translate')('ctxPivotTable.aggregation.minimum'), value: 'Minimum' },
            { id: 9, label: this.$filter('translate')('ctxPivotTable.aggregation.maximum'), detail: this.$filter('translate')('ctxPivotTable.aggregation.maximum'), value: 'Maximum' },
        ];

        // Possible poduct missmatches
        this.reportAggregatedValues = [
            { id: 1, label: this.$filter('translate')('ctxPivotTable.tag.size_on_target'), detail: this.$filter('translate')('ctxPivotTable.tag.size_on_target'), value: 'size_on_target' },
            { id: 2, label: this.$filter('translate')('ctxPivotTable.tag.disk_size'), detail: this.$filter('translate')('ctxPivotTable.tag.disk_size'), value: 'disk_size' },
            { id: 3, label: this.$filter('translate')('ctxPivotTable.tag.transferred_data'), detail: this.$filter('translate')('ctxPivotTable.tag.transferred_data'), value: 'transferred_data' },
            { id: 4, label: this.$filter('translate')('ctxPivotTable.tag.task_duration'), detail: this.$filter('translate')('ctxPivotTable.tag.task_duration'), value: 'task_duration' },
            { id: 5, label: this.$filter('translate')('ctxPivotTable.tag.vm_size'), detail: this.$filter('translate')('ctxPivotTable.tag.vm_size'), value: 'vm_size' }
        ];

        this.tableRenderers = ['Table', 'Heatmap', 'Table Barchart', 'Col Heatmap', 'Row Heatmap'];
    }

    $onInit() {
        this.initPivotLayout();
    }

    $onChanges(changes) {
        if (!this.isEmpty(this.config)) {
            this.busy = true;
            if (changes.data) this.emptyData = changes.data.currentValue.length === 0 || changes.data.currentValue.length === undefined;
            this.noTags = this.config.cols.length === 0 && this.config.rows.length === 0;
            if (!this.isRender()) {
                this.busy = false;
            }

            this.reportType = this.reportTypes.find(({ value }) => value === this.config.rendererName);

            this.reportAggregation = this.config.aggregatorName ? this.reportAggregations.find(({ value }) => value === this.config.aggregatorName) : this.reportAggregation;

            this.reportAggregatedValue = this.config.vals[0] ? this.reportAggregatedValues.find(({ value }) => value === this.config.vals[0]) : this.reportAggregatedValue;

            this.reportData = [...this.data]
            this.changeConfRowsCols(this.config.cols, this.config.rows);
            this.reportConfig = angular.copy(this.config);

            if (changes.data) {
                if (this.isRender()) {
                    this.$timeout(() => {
                        this.initPivotChart();
                    }, 0);
                }
            }

            if (!this.view && this.predefinedTagValues) {
                //Remove used tags from tag pool
                this.config.cols.forEach(element => {
                    if (this.predefinedTagValues.findIndex(item => item.key === element.key) !== -1) {
                        this.predefinedTagValues.splice(this.predefinedTagValues.findIndex(item => item.key === element.key), 1)
                    }
                });

                this.config.rows.forEach(element => {
                    if (this.predefinedTagValues.findIndex(item => item.key === element.key) !== -1) {
                        this.predefinedTagValues.splice(this.predefinedTagValues.findIndex(item => item.key === element.key), 1)
                    }
                });
            }
        }

        if (changes.tags) {
            this.predefinedTagValues = angular.copy(changes.tags.currentValue);
            if (this.predefinedTagValues) this.predefinedTagValues.sort((a, b) => (this.$filter('translate')('ctxPivotTable.tag.' + a.name) > this.$filter('translate')('ctxPivotTable.tag.' + b.name)) ? 1 : -1);

        }

        if (changes.busyReport) {
            if (changes.busyReport.currentValue !== changes.busyReport.previousValue) {
                this.busy = changes.busyReport.currentValue
            }
        }
    }

    isRender() {
        if (this.noTags) {
            return false;
        }
        if (this.emptyData) {
            return false;
        }
        return true;
    }

    formatResponseData() {
        this.reportData.forEach((o) => {
            Object.keys(o).forEach((k) => {
                let item = this.tags.find(key => key.key === k);
                if (o[k] && (item.type === 'datetime' || item.type == 'time_day' || item.type == 'time_hour')) {
                    let utcTime = moment.utc(o[k]);
                    let temp = utcTime.clone().tz(this.export ? this.export.timezone : this.configGeneral.timezone).format("YYYY-MM-DDTHH:mm:ssZ");
                    if (item.type == 'datetime') {
                        if (this.export) {
                            if (this.export.timezone !== 'UTC') {
                                o[item.key] = temp.slice(0, -6);
                            }
                        } else {
                            o[item.key] = temp.slice(0, -6)
                        }
                    } else if (item.type == 'time_day') {
                        o[item.key] = temp.slice(0, 10);
                    } else if (item.type == 'time_hour') {
                        o[item.key] = moment(temp).hour();
                    }
                }
            });
        });
    }

    isEmpty(obj) {
        return obj ? Object.getOwnPropertyNames(obj).length === 0 : true;
    }

    initPivotLayout() {

        if (this.tags) {
            this.predefinedTagValues = angular.copy(this.tags);
            this.predefinedTagValues.sort((a, b) => (this.$filter('translate')('ctxPivotTable.tag.' + a.name) > this.$filter('translate')('ctxPivotTable.tag.' + b.name)) ? 1 : -1);

        }
        this.reportType = this.reportTypes[2];
        // this.reportAggregation = this.reportAggregations[0];
        this.reportAggregatedValue = this.reportAggregatedValues[0];
        this.hideTotalsArray = ['None'];
        this.cssClassesTotals = ['.pvtGrandTotal', '.pvtTotalLabel', '.pvtTotal'];

        this.horizontalSort = 'icon-resize-horizontal';
        this.verticalSort = 'icon-resize-vertical';
        this.columnSort = 'key_a_to_z';
        this.rowSort = 'key_a_to_z';
        this.updatedConfigReport = null;
        this.emptyData = false;
        this.dataTags = {};
    }

    // change tags string array to object array for tag testing
    changeConfRowsCols(cols, rows) {
        if (typeof cols[0] === 'string' || typeof rows[0] === 'string') {
            this.config.cols = cols.map(value => ({ name: this.tagKeyNameChange(value), key: this.toServerCase(value), type: this.tags.filter(tag => tag.key === value)[0].type }));
            this.config.rows = rows.map(value => ({ name: this.tagKeyNameChange(value), key: this.toServerCase(value), type: this.tags.filter(tag => tag.key === value)[0].type }));
        }
    }

    tagKeyNameChange(str) {
        str = str.key ? str.key : str;
        str = str === 'tenant_name' ? 'owner' : str
        str = str === 'duration_s' ? 'duration' : str
        str = str === 'disk_usage_bytes' ? 'disk_usage' : str
        return str;
    }

    createCSV(args) {
        var csv = this.convertArrayOfObjectsToCSV({
            data: this.reportData.sort(function (a, b) {
                var key = Object.keys(a)[0]
                var keyA = a[key];
                var keyB = b[key];
                // Compare the first key values in object
                if (key === 'compressed_size' || key === 'avg_change_rate') {
                    if (keyA < keyB) {
                        return -1;
                    }
                    if (keyA > keyB) {
                        return 1;
                    }
                    return 0;
                } else {
                    keyA = keyA + '';
                    keyB = keyB + '';
                    return keyA.localeCompare(keyB, undefined, { numeric: true, sensitivity: 'base' });
                }
            })
        });
        if (csv == null) {
            // DO NOT DELETE THIS!!! IF you delete this I will find you...
            console.log('No data available.'); // DO NOT DELETE THIS!!! IF you delete this I will find you...
            // DO NOT DELETE THIS!!! IF you delete this I will find you...
        } else {
            // DO NOT DELETE THIS!!! IF you delete this I will find you...
            console.log(csv); // DO NOT DELETE THIS!!! IF you delete this I will find you...
            // DO NOT DELETE THIS!!! IF you delete this I will find you...
        }
    }

    convertArrayOfObjectsToCSV(args) {
        var result, ctr, keys, columnDelimiter, lineDelimiter, data;

        data = args.data || null;
        if (data == null || !data.length) {
            return null;
        }

        columnDelimiter = args.columnDelimiter || ',';
        lineDelimiter = args.lineDelimiter || '\n';

        keys = Object.keys(data[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach(function (item) {
            ctr = 0;
            keys.forEach(function (key) {
                if (ctr > 0) result += columnDelimiter;

                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    }


    initPivotChart() {
        this.output = angular.element(document.querySelector('#output'));
        this.outputWrapper = angular.element(document.querySelector('#output-wrapper-inner'));
        this.initWidth = this.outputWrapper[0].offsetWidth - 20;
        this.initHeight = this.outputWrapper[0].offsetHeight - 60;
        this.initAggregations();
        this.renderReport();
    }

    initAggregations() {
        let aggNone = {};
        let aggCount = {};
        let aggSum = {};
        let aggAverage = {};
        let aggMedian = {};
        let aggSampleVariance = {};
        let aggSampleStandardDeviation = {};
        let aggMin = {};
        let aggMax = {};

        let customNoneAgg = function (val) {
            return function (arg) {
                return function (data, rowKey, colKey) {
                    return {
                        cellValue: 0,
                        push: function () {
                            return this.cellValue++;
                        },
                        value: function () {
                            return this.cellValue;
                        },
                        format: function (x) {
                            const locale = window.navigator.userLanguage || window.navigator.language || 'en';
                            return x.toLocaleString(locale);
                        },
                        numInputs: 0
                    };
                };
            };
        };
        aggNone.None = customNoneAgg();
        aggCount.Count = customNoneAgg();

        let customFormatSum = function (val) {
            return function () {
                let attr = val;
                return function (data, rowKey, colKey) {
                    return {
                        sum: 0,
                        push: function (record) {
                            if (!isNaN(parseFloat(record[attr]))) {
                                return (this.sum += parseFloat(record[attr]));
                            }
                        },
                        value: function () {
                            return this.sum;
                        },
                        format: function (x) {
                            const locale = window.navigator.userLanguage || window.navigator.language || 'en';
                            return x.toLocaleString(locale);
                        },
                        numInputs: attr !== null ? 0 : 1
                    };
                };
            };
        };
        aggSum.Sum = customFormatSum(this.config['vals'] ? this.config['vals'][0] : '');

        let customAverageAgg = function (val) {
            return function () {
                let attr = val;

                return function (data, rowKey, colKey) {
                    return {
                        n: 0.0,
                        m: 0.0,
                        s: 0.0,
                        push: function (record) {
                            var m_new, x;
                            x = parseFloat(record[attr]);
                            if (isNaN(x)) {
                                return;
                            }
                            this.n += 1.0;
                            if (this.n === 1.0) {
                                return this.m = x;
                            } else {
                                m_new = this.m + (x - this.m) / this.n;
                                this.s = this.s + (x - this.m) * (x - m_new);
                                return this.m = m_new;
                            }
                        },
                        value: function () {
                            if (this.n === 0) {
                                return 0 / 0;
                            } else {
                                return this.m;
                            }
                        },

                    };
                }
            }
        };
        aggAverage.Average = customAverageAgg(this.config['vals'] ? this.config['vals'][0] : '');

        let customMedianAgg = function (val) {
            return function () {
                let attr = val;

                return function (data, rowKey, colKey) {
                    return {
                        vals: [],
                        push: function (record) {
                            var x;
                            x = parseFloat(record[attr]);
                            if (!isNaN(x)) {
                                return this.vals.push(x);
                            }
                        },
                        value: function () {
                            var i;
                            if (this.vals.length === 0) {
                                return null;
                            }
                            this.vals.sort(function (a, b) {
                                return a - b;
                            });
                            i = (this.vals.length - 1) * 0.5;
                            return (this.vals[Math.floor(i)] + this.vals[Math.ceil(i)]) / 2.0;
                        },
                    };
                }
            }
        };

        aggMedian.Median = customMedianAgg(this.config['vals'] ? this.config['vals'][0] : '')

        let customSampleVarianceAgg = function (val) {
            return function () {
                let attr = val;

                return function (data, rowKey, colKey) {
                    return {
                        n: 0.0,
                        m: 0.0,
                        s: 0.0,
                        push: function (record) {
                            var m_new, x;
                            x = parseFloat(record[attr]);
                            if (isNaN(x)) {
                                return;
                            }
                            this.n += 1.0;
                            if (this.n === 1.0) {
                                return this.m = x;
                            } else {
                                m_new = this.m + (x - this.m) / this.n;
                                this.s = this.s + (x - this.m) * (x - m_new);
                                return this.m = m_new;
                            }
                        },
                        value: function () {
                            if (this.n <= 1) {
                                return 'N/A';
                            }
                            return this.s / (this.n - 1);
                        },
                    };
                }
            }
        };

        aggSampleVariance.SampleVariance = customSampleVarianceAgg(this.config['vals'] ? this.config['vals'][0] : '')

        let customSampleStandardDeviationAgg = function (val) {
            return function () {
                let attr = val;

                return function (data, rowKey, colKey) {
                    return {
                        n: 0.0,
                        m: 0.0,
                        s: 0.0,
                        push: function (record) {
                            var m_new, x;
                            x = parseFloat(record[attr]);
                            if (isNaN(x)) {
                                return;
                            }
                            this.n += 1.0;
                            if (this.n === 1.0) {
                                return this.m = x;
                            } else {
                                m_new = this.m + (x - this.m) / this.n;
                                this.s = this.s + (x - this.m) * (x - m_new);
                                return this.m = m_new;
                            }
                        },
                        value: function () {
                            if (this.n <= 1) {
                                return 'N/A';
                            }
                            return Math.sqrt(this.s / (this.n - 1));
                        },
                    };
                }
            }
        };

        aggSampleStandardDeviation.SampleStandardDeviation = customSampleStandardDeviationAgg(this.config['vals'] ? this.config['vals'][0] : '');

        let customMinAgg = function (val) {
            return function () {
                let attr = val;

                return function (data, rowKey, colKey) {
                    return {
                        val: null,
                        // sorter: getSort(data != null ? data.sorters : void 0, attr),
                        push: function (record) {
                            var ref, ref1, ref2, x;
                            x = record[attr];
                            x = parseFloat(x);
                            if (!isNaN(x)) {
                                this.val = Math['min'](x, (ref = this.val) != null ? ref : x);
                            }
                        },
                        value: function () {
                            return this.val;
                        },
                        format: function (x) {
                            if (isNaN(x)) {
                                return x;
                            } else {
                                return formatter(x);
                            }
                        },
                        numInputs: attr != null ? 0 : 1
                    };
                }
            }
        };

        aggMin.Minimum = customMinAgg(this.config['vals'] ? this.config['vals'][0] : '');

        let customMaxAgg = function (val) {
            return function () {
                let attr = val;
                return function (data, rowKey, colKey) {
                    return {
                        val: null,
                        // sorter: getSort(data != null ? data.sorters : void 0, attr),
                        push: function (record) {
                            var ref, ref1, ref2, x;
                            x = record[attr];
                            x = parseFloat(x);
                            if (!isNaN(x)) {
                                this.val = Math['max'](x, (ref = this.val) != null ? ref : x);
                            }
                        },
                        value: function () {
                            return this.val;
                        },
                        format: function (x) {
                            if (isNaN(x)) {
                                return x;
                            } else {
                                return formatter(x);
                            }
                        },
                        numInputs: attr != null ? 0 : 1
                    };
                }
            }
        };

        aggMin.Maximum = customMaxAgg(this.config['vals'] ? this.config['vals'][0] : '');

        aggNone = $.extend({}, aggNone, aggCount, aggSum, aggAverage, aggMedian, aggSampleVariance, aggSampleStandardDeviation, aggMin, aggMax); //put 'None' at first place

        this.config.aggregators = this.filterAggregationList(aggNone);
    }

    filterAggregationList(aggList) {
        const aggToBeUsed = ["None", "Count", "Sum", "Average", "Median", "SampleVariance", "SampleStandardDeviation", "Minimum", "Maximum"];

        let aggFiltered = Object.keys(aggList)
            .filter((key) => aggToBeUsed.indexOf(key) !== -1)
            .reduce((obj, key) => {
                obj[key] = aggList[key];
                return obj;
            }, {});

        if (aggToBeUsed.indexOf(this.reportAggregation.value) === -1) {
            aggFiltered[this.reportAggregation.value] = aggList[this.reportAggregation.value];
        }

        return aggFiltered;
    }

    onFilter() {
        if (this.reportData.length >= 0) {
            this.busy = true;
            this.typeChange = true;
            this.$timeout(() => {
                this.renderReport()
            }, 500);
        }
    }

    renderReport() {
        if (!this.typeChange) {
            this.formatResponseData();
        }
        this.prepareDataset();
        if (this.export && this.export.isExportcsv) {
            this.createCSV()
        } else {
            this.typeChange = false;
            if (this.tableRenderers.indexOf(this.config.rendererName) !== -1) {
                this.initTable();
            } else {
                $('#chart-wrapper').empty().append(
                    '<div id="legendRenderer" style="width: calc(100% - 20px);max-height: 230px; overflow: auto;" ctx-custom-scroll-bar="y"></div>' +
                    '<canvas id="chartRenderer"></canvas>');
                if (this.reportData) {
                    this.initChart();
                } else {
                    this.emptyData = true;
                }
            }
        }

        this.busy = false;
    }

    prepareDataset() {
        var recordsForDeletion = [];
        if (this.filteringMode === 'include' && this.config.inclusions && Object.keys(this.config.inclusions).length !== 0) {
            var excludeRecord = false;
            var alreadyExcluded;
            this.data.forEach((record) => {
                Object.keys(record).forEach((key) => {
                    alreadyExcluded = false;
                    excludeRecord = false;
                    Object.keys(this.config.inclusions).forEach((inclKey) => {
                        if (!alreadyExcluded && key === this.toServerCase(inclKey)) {
                            if (this.config.inclusions[inclKey].indexOf(String(record[key])) === -1) {
                                excludeRecord = true;
                            }
                        }
                    });
                    if (excludeRecord && !alreadyExcluded) {
                        recordsForDeletion.push(record);
                        alreadyExcluded = true;
                    }
                });
            })
            this.reportData = this.data.filter(item => recordsForDeletion.indexOf(item) === -1);
        }
        else if (this.filteringMode === 'exclude' && this.config.exclusions && Object.keys(this.config.exclusions).length !== 0) {
            this.data.forEach((record) => {
                Object.keys(this.config.exclusions).forEach((key) => {
                    this.config.exclusions[key].forEach((value) => {
                        if (Object.keys(record).find(item => record[this.toServerCase(key)] + '' === value)) {
                            recordsForDeletion.push(record);
                        }
                    })
                });
            })
            this.reportData = this.data.filter(item => recordsForDeletion.indexOf(item) === -1);
        } else {
            this.reportData = this.data;
        }

        if (this.view) {
            this.$scope.$emit("export-data", this.reportData)
        }
    }

    clearPool(pool) {
        if (pool === 'x' && this.reportConfig.cols.length > 0) {
            this.busy = true;
            this.predefinedTagValues = this.predefinedTagValues.concat(this.config.cols);
            this.reportConfig.cols = [];
        } else if (pool === 'y' && this.reportConfig.rows.length > 0) {
            this.busy = true;
            this.predefinedTagValues = this.predefinedTagValues.concat(this.config.rows)
            this.reportConfig.rows = [];
        }
        this.predefinedTagValues.sort((a, b) => (this.$filter('translate')('ctxPivotTable.tag.' + a.name) > this.$filter('translate')('ctxPivotTable.tag.' + b.name)) ? 1 : -1);
        this.$timeout(() => {
            this.config = this.reportConfig;
        }, 500);
    }

    onReportTypeChange(reportType) {
        this.busy = true;
        this.typeChange = true;
        this.config.rendererName = reportType.value;
        this.reportConfig.rendererName = reportType.value;
        if (this.isRender()) {
            this.$timeout(() => {
                this.renderReport();
            }, 500);
        } else {
            this.busy = false;
        }
    }

    onAggregationTypeChange(aggregationType) {
        this.busy = true;
        this.reportConfig.aggregatorName = aggregationType.value;
        if (aggregationType.value === 'None' || aggregationType.value === 'Count') {
            this.reportConfig.vals = [];
        } else {
            this.reportConfig.vals = this.reportConfig.vals.length > 0 ? this.reportConfig.vals : [this.reportAggregatedValues[0].value];
            this.reportAggregatedValue = this.reportAggregatedValues.filter(obj => {
                return obj.value === this.reportConfig.vals[0];
            })[0]
        }
        this.$timeout(() => {
            this.config = this.reportConfig;
        }, 500);
    }

    onAggregationValueChange(aggregationValue) {
        this.busy = true;
        this.reportConfig.vals = [aggregationValue.value];
        this.$timeout(() => {
            this.config = this.reportConfig;
        }, 500);
    }

    onTagDropdownOpen(item, event) {
        var element = event.target;
        this.tagPosition = element.getBoundingClientRect();
        this.openedDropdown = item.key;
    }

    onDragEnd(index, field) {
        let tempArray = "";
        switch (field) {
            case 'cols':
                tempArray = JSON.stringify(this.reportConfig.cols.map(element => { return element.name }))
                this.reRender = tempArray !== this.colsSize ? true : false; break;
            case 'rows':
                tempArray = JSON.stringify(this.reportConfig.rows.map(element => { return element.name }))
                this.reRender = tempArray !== this.rowsSize ? true : false; break;
            case 'predefined':
                this.reRender = this.predefinedTagValues.length !== this.predefinedsSize ? true : false; break;
        }

        if (this.reRender) {
            this.busy = true;
            this.$timeout(() => {
                this.config = this.reportConfig;
            }, 500);
        }

        this.predefinedTagValues.sort((a, b) => (this.$filter('translate')('ctxPivotTable.tag.' + a.name) > this.$filter('translate')('ctxPivotTable.tag.' + b.name)) ? 1 : -1);
    }

    onDragStart(index, field) {
        switch (field) {
            case 'cols': this.colsSize = JSON.stringify(this.reportConfig.cols.map((element) => { return element.name })); break;
            case 'rows': this.rowsSize = JSON.stringify(this.reportConfig.rows.map((element) => { return element.name })); break;
            case 'predefined': this.predefinedsSize = this.predefinedTagValues.length; break;
        }
    }

    isOpen(item) {
        if (item.key === this.openedDropdown) {
            return true;
        }
    }

    areExcluded(item) {
        if (this.config.exclusions && this.config.exclusions.hasOwnProperty(item.key)) {
            return this.config.exclusions.hasOwnProperty(item.key);
        }
    }

    getOpaqueColor(colorHex) {
        // const opacitiesHex = [
        //     { level: '40percent', value: '66' },
        //     { level: '50percent', value: '80' },
        //     { level: '60percent', value: '99' },
        //     { level: '70percent', value: 'B3' },
        //     { level: '75percent', value: 'BF' },
        //     { level: '80percent', value: 'CC' },
        //     { level: '85percent', value: 'D9' },
        //     { level: '90percent', value: 'E6' },
        // ];

        const opacitiesHex = [
            { level: '40percent', value: '40' },
            { level: '50percent', value: '50' },
            { level: '60percent', value: '60' },
            { level: '70percent', value: '70' },
            { level: '75percent', value: '75' },
            { level: '80percent', value: '80' },
            { level: '85percent', value: '85' },
            { level: '90percent', value: '90' },
        ];


        let lighter = opacitiesHex.find(item => item.level === '50percent').value;
        let darker = opacitiesHex.find(item => item.level === '80percent').value;

        let trans = this.reportConfig.rendererName === 'Area Chart' ? lighter : darker;
        return this.convertHexToRGBA(colorHex, trans);
    }

    convertHexToRGBA(hex, opacity) {
        const tempHex = hex.replace('#', '');
        const r = parseInt(tempHex.substring(0, 2), 16);
        const g = parseInt(tempHex.substring(2, 4), 16);
        const b = parseInt(tempHex.substring(4, 6), 16);

        return `rgba(${r},${g},${b},${opacity / 100})`;
    };

    initChart() {
        let ctx = document.getElementById('chartRenderer');
        let legendHtmlDiv = document.getElementById('legendRenderer');
        this.reportConfig = angular.copy(this.config);

        this.aggregator = this.config.aggregators[this.reportAggregation.value](this.config['vals']);
        this.totalsCount = 0;
        this.rowKey = [];
        this.colKey = [];
        this.rowKeys = [];
        this.colKeys = [];
        this.rowTotals = {};
        this.rowValues = {};
        this.colTotals = {};
        this.colValues = {};
        this.allTotal = this.aggregator(this, [], []);
        this.flatColKeys = [];
        this.flatRowKeys = [];
        this.tree = {};
        this.aggregateData();

        let mapObject = this.reportConfig.colOrder && this.reportConfig.colOrder === 'key_a_to_z' ? Object.entries(this.tree).sort() : Object.entries(this.tree).reverse();
        let labels = mapObject.map((value, index) => { return value[0] });
        let unorderedValues = mapObject.map((value, index) => { return this.reportConfig.rows.length && this.reportConfig.cols.length ? value[1] : value[1].value() });

        let values = [];

        if (this.reportConfig.rows.length ^ this.reportConfig.cols.length) {
            // sort 2 Arrays the same way so data remains consistent
            let tempArray = [];
            //1) join the arrays
            for (var j = 0; j < labels.length; j++)
                tempArray.push({ 'label': labels[j], 'value': unorderedValues[j] });

            //2) sort:
            tempArray.sort((a, b) => this.sortChartDataset(a.label, b.label));

            //3) separate the arrays back out:
            for (var k = 0; k < tempArray.length; k++) {
                labels[k] = tempArray[k].label;
                unorderedValues[k] = tempArray[k].value;
            }
            values = unorderedValues;
        } else {
            unorderedValues.forEach((value) => {
                let orderedValue = {};

                Object.keys(value).sort((a, b) => this.sortChartDataset(a, b)).forEach(function (key) {
                    orderedValue[key] = value[key];
                });

                values.push(orderedValue);
            });
        }

        let colors = [];
        const colorsHex = ['#1DB6FD', '#337EEA', '#685FFF', '#7146CE', '#9348E1', '#A334BF', '#DA399A', '#FC59AA', '#E5728A', '#EA8571', '#E8A245', '#E7BA4B', '#CED70C', '#ADC814', '#6FC19B', '#20D19A', '#3EDAC6', '#35C3BB', '#00B9CA'];
        colors = colorsHex;

        let chartType = '';
        let chartOptions = this.getChartOptions(this.reportConfig.rendererName);
        switch (this.reportConfig.rendererName) {
            case 'Bar Chart': chartType = 'bar'; break;
            case 'Stacked Bar Chart': chartType = 'bar'; break;
            case 'Horizontal Bar Chart': chartType = 'horizontalBar'; break;
            case 'Horizontal Stacked Bar Chart': chartType = 'horizontalBar'; break;
            case 'Line Chart': chartType = 'line'; break;
            case 'Area Chart': chartType = 'line'; break;
            case 'Scatter Chart': chartType = 'scatter'; break;
            case 'Radar Chart': chartType = 'radar'; break;
            case 'PolarArea Chart': chartType = 'polarArea'; break;
            case 'Doughnut Chart': chartType = 'doughnut'; break;
        }

        let datasets = [];
        let dataset = {
            label: this.reportConfig.vals[0],
            fill: this.reportConfig.rendererName !== 'Line Chart' && this.reportConfig.rendererName !== 'Scatter Chart',
            data: values,
            fillColor: this.getOpaqueColor(colors[0]),
            borderColor: this.reportConfig.rendererName === 'Line Chart' ? this.getOpaqueColor(colors[0]) : '',
            backgroundColor: this.getOpaqueColor(colors[0]),
            borderWidth: this.reportConfig.rendererName === 'Line Chart' ? 2 : 1
        };

        if ((this.reportConfig.cols && this.reportConfig.cols.length && this.reportConfig.rows && this.reportConfig.rows.length) || ((this.reportConfig.rows.length && !this.reportConfig.cols.length) && !this.reportConfig.rendererName.indexOf('Horizontal') !== -1) || ((!this.reportConfig.rows.length && this.reportConfig.cols.length) && this.reportConfig.rendererName.indexOf('Horizontal') !== -1)) {
            let horizontalNest = this.colTotals;
            let horizontalMapObject = this.reportConfig.colOrder && this.reportConfig.colOrder === 'key_a_to_z' ? Object.entries(horizontalNest).sort() : Object.entries(horizontalNest).reverse();
            let horizontalLabels = labels;
            labels = horizontalMapObject.map((value, index) => { return value[0] });

            labels.sort((a, b) => this.sortChartDataset(a, b));

            values.forEach((item, index) => {
                let randomColor = index < colors.length ? this.getOpaqueColor(colors[index]) : this.getOpaqueColor(colors[index % colors.length]);

                let tempData = {};
                dataset.data = [];
                tempData = angular.copy(dataset);
                tempData.label = horizontalLabels[index];
                tempData.parentData = Object.entries(item).map((value, index) => {
                    return value[0];
                })[0];
                tempData.borderColor = !tempData.fill ? randomColor : 'rgb(255,255,255)';
                tempData.fillColor = !tempData.fill ? randomColor : '';
                tempData.backgroundColor = !tempData.fill ? tempData.fillColor : randomColor;
                tempData.borderWidth = !tempData.fill ? 2 : 1;

                if (this.reportConfig.rows.length && this.reportConfig.cols.length) {
                    // console.log(labels.indexOf(tempData.parentData))
                    Object.entries(item).sort().map((value, index) => {
                        if (this.reportConfig.rendererName === 'Scatter Chart') {
                            tempData.data[labels.indexOf(value[0])] = {
                                'x': labels.indexOf(value[0]),
                                'y': value[1].value()
                            };
                        } else {
                            tempData.data[labels.indexOf(value[0])] = value[1].value();
                        }
                    });
                } else {
                    tempData.data = [item];
                }
                datasets.push(tempData);
            });
        } else {
            datasets.push(dataset);
        }

        // if (datasets.length > 1) {
        //     labels.sort((a, b) => this.sortChartDataset(a, b));
        //     datasets.sort((a, b) => this.sortChartDataset(a.parentData, b.parentData));
        // } else {
        // }

        let legendOptionsGlobal = { legend: { display: false } };

        let legendCallback = {
            legendCallback: function (chart) {
                let legendHtml = [];
                legendHtml.push('<div class="legendContainer">');
                for (var i = 0; i < chart.data.datasets.length; i++) {
                    if (chart.legend.legendItems[i].text) {
                        let legendItemBoxColor = chart.config.type !== 'line' ? chart.legend.legendItems[i].fillStyle : chart.data.datasets[i].backgroundColor;
                        legendHtml.push(
                            '<div id="label' + chart.legend.legendItems[i].datasetIndex + '" class="legendItemContainer"> ' +
                            '<div class="legendItemBox" style="background-color:' + legendItemBoxColor + ';"></div>' +
                            '<div class="legendItemLabel">' + chart.legend.legendItems[i].text + '</div></div>');
                    }
                }
                legendHtml.push('</div>');
                return legendHtml.join("");
            }
        };

        let updateLegendAction = function (obj, i) {
            var index = obj.legend.legendItems[i].datasetIndex;

            var ci = obj.chart;
            var meta = ci.getDatasetMeta(index);
            if (meta.hidden === null) {
                meta.hidden = !ci.data.datasets[index].hidden;
                document.getElementById("label" + i).setAttribute('style', 'text-decoration: line-through;');
            } else {
                meta.hidden = null;
                document.getElementById("label" + i).removeAttribute('style', 'text-decoration: line-through;');
            }

            ci.update();
        };

        let highlightOnHover = function (obj, i, isHighlight) {
            if (!isHighlight) {
                var hoveredDatasetIndex = obj.legend.legendItems[i].datasetIndex;
                obj.updateHoverStyle(obj.getDatasetMeta(hoveredDatasetIndex).data, null, false);
                obj.draw();
            } else {
                var hoveredDatasetIndex = obj.legend.legendItems[i].datasetIndex;
                obj.updateHoverStyle(obj.getDatasetMeta(hoveredDatasetIndex).data, null, true);
                obj.draw();
            }
        }

        this.myChart = new Chart(ctx, {
            type: chartType,
            data: {
                labels: labels,
                datasets: datasets
            },
            options: $.extend({}, chartOptions, legendOptionsGlobal, legendCallback),
            plugins: [{
                afterLayout: (chart) => {
                    chart.legend.legendItems.forEach(
                        (label) => {
                            let properties = this.reportConfig.rows;

                            switch (this.reportConfig.rendererName) {
                                case 'Doughnut Chart':
                                case 'Horizontal Bar Chart':
                                case 'Horizontal Stacked Bar Chart':
                                    // label.fillStyle = 'rgb(192,192,192)';
                                    properties = this.reportConfig.cols;
                            }

                            if (this.reportConfig.rows.length === 0 && this.reportConfig.cols.length !== 0 && this.reportConfig.vals[0]) {
                                if (this.reportConfig.rendererName === 'Horizontal Bar Chart' || this.reportConfig.rendererName === 'Horizontal Stacked Bar Chart') {
                                    label.text = label.text ? this.formatTick(label.text, properties) : this.aggregatorName ? this.aggregatorName : 'Count';
                                } else {
                                    label.text = this.reportAggregatedValues.find((item) => item.value === this.reportConfig.vals[0]).label
                                }
                            } else {
                                if ((this.reportConfig.rendererName === 'Horizontal Bar Chart' || this.reportConfig.rendererName === 'Horizontal Stacked Bar Chart') && this.reportConfig.vals[0]) {
                                    label.text = label.text !== this.reportConfig.vals[0] ? this.formatTick(label.text, properties) : this.reportAggregatedValues.find((item) => item.value === this.reportConfig.vals[0]).label
                                } else {
                                    label.text = label.text ? this.formatTick(label.text, properties) : this.aggregatorName ? this.aggregatorName : 'Count';
                                }
                            }

                            return label;
                        }
                    )
                }
            }]
        });

        legendHtmlDiv.innerHTML = this.myChart.generateLegend();

        var height = $('#legendRenderer').height()
        $('#chart-wrapper').css('height', `calc(100% - ${height}px)`);

        //Add event listener for the custom generated legend - needs to be added after Html DOM elements of the custom legend are created
        for (let i = 0; i < this.myChart.data.datasets.length; i++) {
            if (this.myChart.legend.legendItems[i].text) {
                document.getElementById("label" + i).addEventListener("click", (event) => { updateLegendAction(this.myChart, i) }, false);
                document.getElementById("label" + i).addEventListener("mouseenter", (event) => { highlightOnHover(this.myChart, i, true) }, false);
                document.getElementById("label" + i).addEventListener("mouseleave", (event) => { highlightOnHover(this.myChart, i, false) }, false);

            }
        }

        // add three dots if legend too big on export
        if (this.export) {
            let legendRendererHeight = $('#legendRenderer').height()
            let legendContainerHeight = $('.legendContainer').height()
            if (legendContainerHeight > legendRendererHeight) {
                $('#legendRenderer').append('<div class="more-button">...</div>');
                $('#legendRenderer').css("overflow", "hidden");
            }
        } else {
            //recompile legendRenderer element to apply custom scrollbar
            this.$compile($('#legendRenderer'))(this.$scope);
        }
    }

    truncateString(initialString) {
        if (initialString.length > 70) {
            var shortString = initialString.substring(0, 70);
            return shortString + '...';
        }
        return initialString;
    }

    getChartOptions(type) {
        let tickFontOptions = {
            fontFamily: "Open Sans,Sans-Serif",
            fontSize: 12,
            fontColor: '#555',
            fontWeight: '500'
        }
        let labelFontOptions = {
            fontFamily: "Open Sans,Sans-Serif",
            fontSize: 14,
            fontColor: '#666',
            fontWeight: '500'
        }
        let options = {};

        let xAxisLabels = this.reportConfig.cols.map((item) => this.toSentanceCase(item.name)).join(', ');
        let yAxisLabels = this.reportConfig.rows.map((item) => this.toSentanceCase(item.name)).join(', ');
        switch (type) {
            case 'Bar Chart': options = {
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.reportConfig.cols, true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        }
                    }],
                },
                responsive: true,
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                }
            }; break;
            case 'Stacked Bar Chart': options = {
                maintainAspectRatio: false,
                responsive: true,
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    mode: 'point',
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.reportConfig.cols, true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }]
                }
            }; break;
            case 'Horizontal Bar Chart': options = {
                elements: {
                    rectangle: {
                        borderWidth: 2
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                var string = this.formatTick(value, this.reportConfig.rows, true);
                                return this.truncateString(string);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight

                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                var string = this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                                return this.truncateString(string);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }],
                },
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    mode: 'point',
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.rows);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.cols) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                }
            }; break;
            case 'Horizontal Stacked Bar Chart': options = {
                elements: {
                    rectangle: {
                        borderWidth: 2,
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    mode: 'point',
                    intersect: true,
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.rows);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.cols) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        beginAtZero: true,
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                var string = this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                                return this.truncateString(string);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                var string = this.formatTick(value, this.reportConfig.rows, true);
                                return this.truncateString(string);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        }
                    }]
                }
            }; break;
            case 'Line Chart': options = {
                responsive: true,
                maintainAspectRatio: false,
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    mode: 'point',
                    intersect: true,
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        // type: 'linear',
                        gridLines: {
                            display: false
                        },
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.reportConfig.cols, true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }]
                }
            }; break;
            case 'Area Chart': options = {
                maintainAspectRatio: false,
                spanGaps: false,
                elements: {
                    line: {
                        tension: 0.4
                    }
                },
                plugins: {
                    filler: {
                        propagate: false
                    }
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.reportConfig.cols, true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        }
                    }]
                },
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                }
            }; break;
            case 'Scatter Chart': options = {
                maintainAspectRatio: false,
                responsive: true,
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    mode: 'point',
                    intersect: true,
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            if (this.reportConfig.cols.length > 0 && this.reportConfig.rows.length > 0) {
                                label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            } else {
                                label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));

                            }
                            return label;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        type: 'category',
                        gridLines: {
                            display: false
                        },
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: xAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.reportConfig.cols, true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: yAxisLabels,
                            fontSize: labelFontOptions.fontSize,
                            fontFamily: labelFontOptions.fontFamily,
                            fontColor: labelFontOptions.fontColor,
                            fontStyle: labelFontOptions.fontStyle
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return this.formatTick(value, this.tags.filter(tag => tag.key === this.reportConfig.vals[0]), true);
                            },
                            fontSize: tickFontOptions.fontSize,
                            fontFamily: tickFontOptions.fontFamily,
                            fontColor: tickFontOptions.fontColor,
                            fontStyle: tickFontOptions.fontWeight
                        },
                    }]
                }
            }; break;
            case 'Radar Chart': options = {
                legend: {
                    position: 'top',
                },
                scale: {
                    ticks: {
                        beginAtZero: true,
                        fontSize: tickFontOptions.fontSize,
                        fontFamily: tickFontOptions.fontFamily,
                        fontColor: tickFontOptions.fontColor,
                        fontStyle: tickFontOptions.fontWeight
                    },

                }
            }; break;
            case 'PolarArea Chart': options = {
                responsive: true,
                legend: {
                    position: 'top',
                },
                scale: {
                    ticks: {
                        beginAtZero: true,
                        fontSize: tickFontOptions.fontSize,
                        fontFamily: tickFontOptions.fontFamily,
                        fontColor: tickFontOptions.fontColor,
                        fontStyle: tickFontOptions.fontWeight
                    },
                    reverse: false
                },
                animation: {
                    animateRotate: false,
                    animateScale: true
                }
            }; break;
            case 'Doughnut Chart': options = {
                responsive: true,
                legend: {
                    position: 'top',
                    doughnutMode: true
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                hover: {
                    mode: 'point'
                },
                tooltips: {
                    callbacks: {
                        title: (tooltipItem, data) => {
                            let title = tooltipItem[0].label.replace(String.fromCharCode(765), ' ');
                            title = this.formatTick(tooltipItem[0].label, this.reportConfig.cols);
                            title = title[0] === 'undefined' ? '' : title;
                            return title;
                        },
                        label: (tooltipItem, data) => {
                            var label = this.reportConfig.vals[0] ? this.toSentanceCase(this.reportConfig.vals[0]) : '';

                            label = label.replace(String.fromCharCode(765), ' ');
                            label += (label && this.reportConfig.vals[0] !== data.datasets[tooltipItem.datasetIndex].label) ?
                                ' ( ' + this.formatTick(data.datasets[tooltipItem.datasetIndex].label, this.reportConfig.rows) + '): ' : ': ';

                            label += this.formatTick(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], this.tags.filter(tag => tag.key === this.reportConfig.vals[0]));
                            return label;
                        }
                    }
                }
            }; break;
        }

        return options;
    }

    sortChartDataset(a, b) {
        let side = this.reportConfig.colOrder ? this.reportConfig.colOrder === 'key_a_to_z' ? 1 : -1 : 1;
        if (a.indexOf('name') > 0) {
            if (a < b) {
                return -1 * side;
            }
            if (a > b) {
                return side;
            }
            return 0;
        } else {
            a = a + '';
            b = b + '';
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }) * side;
        }
    }

    formatTick(value, properties, axis = false) {
        let result = '';
        const locale = (!this.export) ? window.navigator.userLanguage || window.navigator.language || 'en' : this.export.locale;
        value = !$.isNumeric(value) && properties.length > 1 ? value = value.split(String.fromCharCode(765)) : [value];
        properties.forEach((property, index) => {
            let attributeType = property.type ? property.type : property;
            switch (attributeType) {
                case 'size': {
                    if (isNaN(value[index]) || value[index] === null || value[index] < 0) {
                        result += 'N/A'; //initialized as N/A because the tag is used in aggregations
                    } else {
                        let temp = axis ? this.utilsService.fromBytesTo(value[index], 'gib') : this.utilsService.fromBytes(value[index]);
                        let unit = !temp.unit ? '' : (temp.unit === 'byte' ? 'B' : temp.unit.charAt(0).toUpperCase() + temp.unit.slice(1, 2) + temp.unit.charAt(2).toUpperCase());
                        result += axis ? temp.toFixed(2) + ' GiB' : temp.value + ' ' + unit;
                    }
                }
                    break;
                case 'datetime': {
                    if (value[index] === 'null') {
                        result += 'N/A';
                    } else {
                        let temp;
                        const dateFormat = this.configGeneral.dateFormats['shortSec'];
                        temp = moment(value[index]).locale(locale).format(dateFormat['datetime']);
                        result += temp === 0 ? '' : temp;
                    }
                }
                    break;
                case 'time_day': {
                    if (value[index] === 'null') {
                        result += 'N/A';
                    } else {
                        let temp;
                        const dateFormat = this.configGeneral.dateFormats['short'];
                        temp = moment(value[index]).locale(locale).format(dateFormat['date']);
                        result += temp === 0 ? '' : temp;
                    }
                }
                    break;
                case 'time_hour': {
                    if (value[index] === 'null') {
                        result += 'N/A';
                    } else {
                        result += value[index] === null || value[index] === undefined ? '' : value[index] + 'H';
                    }
                }
                    break;
                case 'duration': {
                    let temp = 'N/A'; //initialized as N/A because the tag is used in aggregations
                    if ($.isNumeric(value[index])) {
                        temp = new Date(value[index] * 1000).toISOString().substr(11, 8);
                    }
                    result += temp === 0 ? '' : temp;
                }
                    break;
                case 'percentage': {
                    if ($.isNumeric(value[index])) {
                        result += (value[index] * 100).toFixed(0) + "%";
                    } else {
                        result += value[index] || '';
                    }
                }
                    break;
                default: result += value[index] === "null" ? 'N/A' : value[index]; break;
            }
            result += ' ';
        });
        return result === '' ? value : result;
    }

    formatTableValue(value, property) {
        let result = '';
        let attributeType = property.type ? property.type : property;
        const locale = (!this.export) ? window.navigator.userLanguage || window.navigator.language || 'en' : this.export.locale;
        switch (attributeType) {
            case 'size': {
                if (isNaN(value) || value === null || value < 0) {
                    result += '';
                } else {
                    let temp = this.utilsService.fromBytes(value);
                    let unit = !temp.unit ? '' : (temp.unit === 'byte' ? 'B' : temp.unit.charAt(0).toUpperCase() + temp.unit.slice(1, 2) + temp.unit.charAt(2).toUpperCase());
                    result += temp.value + ' ' + unit;
                }
            }
                break;
            case 'datetime': {
                if (value === 'null') {
                    result = '';
                } else {
                    const dateFormat = this.configGeneral.dateFormats['shortSec'];
                    let temp = moment(value).locale(locale).format(dateFormat['datetime']);
                    result += temp === 0 ? '' : temp;
                }
            }
                break;
            case 'time_day': {
                if (value === 'null') {
                    result = '';
                } else {
                    const dateFormat = this.configGeneral.dateFormats['short'];
                    let temp = moment(value).locale(locale).format(dateFormat['date']);
                    result += temp === 0 ? '' : temp;
                }
            }
                break;
            case 'time_hour': {
                if (value === 'null') {
                    result = '';
                } else {
                    result += value === null || value === undefined ? '' : value + 'H';
                }
            }
                break;
            case 'duration': {
                if (value === 'null') {
                    result = '';
                } else {
                    let temp = ''; //initialized as N/A because the tag is used in aggregations
                    if ($.isNumeric(value)) {
                        temp = new Date(value * 1000).toISOString().substr(11, 8);
                    }
                    result += temp === 0 ? '' : temp;
                }
            }
                break;
            case 'percentage': {
                if ($.isNumeric(value)) {
                    result += (value * 100).toFixed(0) + "%";
                } else {
                    result += value || '';
                }
            }
                break;
            default: result += value === "null" ? '' : value; break;
        }
        result += ' ';
        return result === '' ? value : result;
    }

    onClose() {
        this.showView = false;
        this.dataTags = {};
        this.initLayout = false;
        this.parameterChange = false;
        this.updateconfig = {};
        this.config = {};
        this.reportData = {};
        this.versionDescription = '';
        this.chartReady = false;
        this.saveAs = false;
        if (!this.isEmpty(this.myChart)) {
            this.myChart.destroy();
        }
    }

    // Possible poduct missmatches
    toServerCase(str) {
        str = str.toLowerCase().split(' ');
        if (str[str.length - 1] === '') {
            str.splice(-1, 1)
        }
        str = str.join('_')
        str = str === 'owner' ? 'tenant_name' : str
        str = str === 'job_duration' ? 'duration' : str
        // str = str === 'backup_status' ? 'status' : str
        str = str === 'compliance_status' ? 'compliancy_status' : str
        str = str === 'compliance_reason' ? 'compliancy_reason' : str
        str = str === 'disk_usage' ? 'disk_usage_bytes' : str
        return str;
    }

    toSentanceCase(str) {
        str = str.key ? str.key : str;
        str = str === 'tenant_name' ? 'owner' : str
        str = str === 'duration' ? 'job_duration' : str
        str = str === 'compliancy_status' ? 'compliance_status' : str
        str = str === 'compliancy_reason' ? 'compliance_reason' : str
        str = str === 'disk_usage_bytes' ? 'disk_usage' : str
        if (str.indexOf('_') > -1) {
            str = str.toLowerCase().split('_');
            for (let i = 0; i < str.length; i++) {
                str[i] = i === 0 ? str[i].charAt(0).toUpperCase() + str[i].slice(1) : str[i];
                if (str[i] === 'Vm' || str[i] === 'uuid' || str[i] === 'Ip') {
                    str[i] = str[i].toUpperCase();
                }
            }
            return str.join(' ')
        } else {
            str = str.toLowerCase().split('_');
            for (let i = 0; i < str.length; i++) {
                str[i] = i === 0 ? str[i].charAt(0).toUpperCase() + str[i].slice(1) : str[i];
            }
            return str.join(' ')
        }
    }


    isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }


    // TABLE

    initTable() {

        var headerData = d3.nest();
        var bodyData = d3.nest();
        var bodyDataAgg = d3.nest();
        this.reportConfig = angular.copy(this.config);


        this.xAxis = this.reportConfig.cols;
        this.yAxis = this.reportConfig.rows;

        this.reportConfig.aggregatorName === 'None' ? this.totalsColumn = false : this.totalsColumn = true;


        // prepare data for header
        this.xAxis.forEach((key) => {
            headerData.key((d) => {
                return d[key.key];
            })
                .rollup((values) => {
                    return 'null';
                })
        });

        //prepare data for 2D body values or 3d left body "headers"
        this.yAxis.forEach((key) => {
            bodyData.key((d) => {
                return d[key.key];
            })
                .rollup((values) => {
                    return 'null';
                })
        });
        if (this.reportData) {
            var headerNestedData = headerData.map(this.reportData)
            var bodyNestedData = bodyData.map(this.reportData)
        }

        this.generateTable(headerNestedData, bodyNestedData)
        this.afterGenerate()
    }

    afterGenerate() {
        // set fixed header
        $('.pane-hScroll').scroll(function () {
            $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
        });

        // // recompile for sorting to work
        $('.sortableCtx').attr('ng-click', '$ctrl.sortTableClick($event)');
        this.$compile($('.sortableCtx'))(this.$scope);

        //recompile for tooltips to work
        this.$compile($('.pivotTable tbody td'))(this.$scope);
    }

    generateTable(headerNestedData, bodyNestedData) {
        this.busy = true;
        this.aggregator = this.reportConfig.aggregators[this.reportAggregation.value](this.reportAggregatedValue.value);
        this.totalsCount = 0;
        this.rowKey = [];
        this.colKey = [];
        this.rowKeys = [];
        this.colKeys = [];
        this.rowTotals = {};
        this.rowValues = {};
        this.colTotals = {};
        this.colValues = {};
        this.allTotal = this.aggregator(this, [], []);
        this.flatColKeys = [];
        this.flatRowKeys = [];
        this.tree = {};

        //Create  HTML Table header,body,footer table elements and append them to specific div.
        this.table = document.createElement("TABLE");
        this.table.border = "1";
        this.table.setAttribute('class', 'pivotTable');

        var header = this.table.createTHead();

        var tblHeader = document.getElementById("table-wrapper");
        tblHeader.innerHTML = "";
        tblHeader.appendChild(this.table);

        this.body = this.table.createTBody();

        if (this.totalsColumn) {
            if (this.export) {
                this.footer = (this.export) ? this.table.createTBody() : this.table.createTFoot();
            } else {
                this.footer = this.table.createTFoot();
            }
        } else {
            this.tableFooter ? this.tblFoot.removeChild(this.tableFooter) : null
            this.tableFooter = null;
        }

        //Get the count of columns.
        this.xAxisCount = this.reportConfig.cols.length;
        this.yAxisCount = this.reportConfig.rows.length;

        //Add the header row.
        for (var i = 0; i < this.xAxisCount + 1; i++) {
            var row = header.insertRow(i);
            for (var j = 0; j < this.yAxisCount + 1; j++) {

                // create col/row spanned cell if on first row and column and y and x axis values exist
                if (row.rowIndex === 0 && this.yAxisCount > 0 && this.xAxisCount > 0 && j === 0) {
                    var headerCell = document.createElement("TH");
                    headerCell.innerHTML = '';
                    headerCell.setAttribute('rowSpan', this.xAxisCount)
                    headerCell.setAttribute('colSpan', this.yAxisCount)
                    headerCell.setAttribute('class', 'empty-corner-head');
                    row.appendChild(headerCell);
                }

                // Write y axis labels when last header row is applied
                if (i === this.xAxisCount) {
                    if (this.reportConfig.rows[j]) {
                        var headerCell = document.createElement("TH");
                        headerCell.setAttribute('class', 'table-head ctx-grid-cell ctx-grid-header-cell ng-scope sortableCtx sort asc');
                        headerCell.innerHTML = this.reportConfig.rows[j] ? this.toSentanceCase(this.reportConfig.rows[j].name) : '';

                        // headerCell.setAttribute('ctx-tooltip', '');
                        if (!window.document.documentMode) {
                            headerCell.style.top = i <= 1 ? (i * 35) + 'px' : (i * 35) - (i - 1) + 'px'
                        }

                        headerCell.setAttribute('title', headerCell.innerHTML);
                        row.appendChild(headerCell);
                    }
                }

                // write x axis labels on the next column after y axis labels
                if ((j > this.yAxisCount - 1) && (this.xAxisCount > 0)) {
                    var headerCell = document.createElement("TH");

                    headerCell.setAttribute('class', 'table-head ctx-grid-cell ctx-grid-header-cell ng-scope ');

                    //apply sticky header
                    if (!window.document.documentMode) {
                        headerCell.style.top = i <= 1 ? (i * 35) + 'px' : (i * 35) - (i - 1) + 'px'
                    }

                    headerCell.innerHTML = this.reportConfig.cols[i] ? this.toSentanceCase(this.reportConfig.cols[i].name) : '';
                    headerCell.setAttribute('title', headerCell.innerHTML);
                    row.appendChild(headerCell);
                }
            }

            //increment i so we dont create bottom empty header value if 2D table
            if (this.yAxisCount === 0 && (this.xAxisCount === i + 1)) i++;
        }

        // Add header values if more than "2D table"
        if (this.xAxisCount !== 0) {
            const tr = this.table.getElementsByTagName("tr");
            this.idx = -1;

            this.addHeaderValuesRecursive(headerNestedData, tr);
        }


        if (this.reportData && !(this.xAxisCount > 0)) {
            this.idx = -1;
            this.addBodyHeaderValuesRecursive(bodyNestedData, false);
            if (this.totalsColumn) {
                this.aggregateData();
                this.generateBody(this.body);
                this.generateTotals(false)
            }
        } else {
            if (this.yAxisCount > 0) {
                this.idx = -1;
                this.addBodyHeaderValuesRecursive(bodyNestedData, true);
            }
            this.aggregateData();

            this.generateBody(this.body);
            if (this.totalsColumn) {
                this.generateTotals(true)
            }
        }
    }

    getLowestLevelCount(obj) {
        let counter = 0;
        if (Object.keys(obj).length > 0) { // Checks if token has children.
            {
                for (const [key, value] of Object.entries(obj)) {
                    if (value instanceof Object) {
                        counter += this.getLowestLevelCount(value);
                    } else {
                        counter += 1;
                    }
                }
            }
        }
        else // Lowest-level elem.
        {
            counter += 1;
        }
        return counter;
    }

    addHeaderValuesRecursive(objUnsorted, tr) {
        var k;
        var obj = {};
        this.idx++;
        var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

        Object.keys(objUnsorted).sort(collator.compare).forEach(function (key) {
            obj[key] = objUnsorted[key];
        });
        if (obj instanceof Object) {
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    if (!Array.isArray(obj)) {
                        const colspan = this.getLowestLevelCount(obj[k]);
                        var headerCell = document.createElement("TH");
                        // console.log(this.idx)
                        // console.log(this.config.cols)
                        headerCell.innerHTML = k ? this.formatTableValue(k, this.config.cols[this.idx]) : '';
                        headerCell.setAttribute('title', headerCell.innerHTML);

                        this.colKey.push(k);
                        // if last row in header add rowspan and stop recursion scan
                        if (this.xAxisCount !== this.idx + 1) {
                            headerCell.setAttribute('colSpan', colspan);
                            headerCell.setAttribute('class', 'header-value')
                            //apply sticky header

                            if (!window.document.documentMode) {
                                headerCell.style.position = 'sticky'
                                headerCell.style.top = this.idx <= 1 ? (this.idx * 35) + 'px' : (this.idx * 35) - (this.idx - 1) + 'px'
                            }
                            tr[this.idx].appendChild(headerCell);
                            this.addHeaderValuesRecursive(obj[k], tr);
                        } else {
                            headerCell.setAttribute('class', 'header-value ng-scope sortableCtx sort asc')
                            headerCell.setAttribute('rowSpan', 2);
                            tr[this.idx].appendChild(headerCell);

                            //apply sticky header
                            if (!window.document.documentMode) {
                                headerCell.style.position = 'sticky'
                                headerCell.style.top = this.idx <= 1 ? (this.idx * 35) + 'px' : (this.idx * 35) - (this.idx - 1) + 'px'
                            }
                            this.flatColKeys.push(this.colKey.join(String.fromCharCode(765)));
                            this.colKey.pop()
                        }
                    }
                }
            }
            this.idx--;
            this.colKey.pop()
        };
    }

    addBodyHeaderValuesRecursive(objUnsorted, is3Dtable, row) {
        var k;
        this.idx++;
        var obj = {};
        this.indexchanged = true;
        var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

        Object.keys(objUnsorted).sort(collator.compare).forEach(function (key) {
            obj[key] = objUnsorted[key];
        });
        if (obj instanceof Object) {
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    if (!Array.isArray(obj)) {
                        const rowspan = this.getLowestLevelCount(obj[k]);
                        var headerCell = document.createElement("TH");
                        headerCell.setAttribute('class', is3Dtable ? 'body-header' : 'body-content');
                        headerCell.innerHTML = k ? this.formatTableValue(k, this.config.rows[this.idx]) + this.addInvisibleValueDiv(k) : '';
                        headerCell.setAttribute('title', this.formatTableValue(k, this.config.rows[this.idx]));

                        this.rowKey.push(k);

                        // if last row in header add rowspan and stop recursion scan
                        if (this.yAxisCount !== this.idx + 1) {
                            headerCell.setAttribute('rowSpan', rowspan);
                            headerCell.setAttribute('valign', "top");

                            //apply sticky header TODO
                            // headerCell.style.position = 'sticky'
                            // headerCell.style.left = this.idx * 34 + 'px'

                            if (!this.indexchanged || this.idx === 0) {
                                var row = this.body.insertRow();
                            }

                            this.indexchanged = false;
                            row.appendChild(headerCell);
                            this.addBodyHeaderValuesRecursive(obj[k], is3Dtable ? true : false, row);
                        } else {
                            if (!this.indexchanged || this.idx === 0) {
                                var row = this.body.insertRow();
                            }
                            this.indexchanged = false;
                            headerCell.setAttribute('valign', "top");

                            //apply sticky header TODO
                            // headerCell.style.position = 'sticky'
                            // headerCell.style.left = this.idx * 34 + 'px'

                            if (is3Dtable) {
                                headerCell.setAttribute('colSpan', 2);
                            }
                            row.appendChild(headerCell);

                            this.flatRowKeys.push(this.rowKey.join(String.fromCharCode(765)));
                            this.rowKey.pop()
                        }

                    }
                }
            }
            this.idx--;
            this.rowKey.pop()
        };
    }

    aggregateData() {
        this.reportData.forEach((record) => {
            var colKey, flatColKey, flatRowKey, l, len1, len2, n, ref, ref1, ref2, ref3, rowKey, x;

            colKey = [];
            rowKey = [];
            ref = this.config.cols;
            for (l = 0, len1 = ref.length; l < len1; l++) {
                x = ref[l].key;
                colKey.push((ref1 = record[x]) != null ? ref1 : "null");
            }
            ref2 = this.config.rows;
            for (n = 0, len2 = ref2.length; n < len2; n++) {
                x = ref2[n].key;
                rowKey.push((ref3 = record[x]) != null ? ref3 : "null");
            }

            let tempRowKey = this.config.rendererName !== 'Horizontal Bar Chart' &&
                this.config.rendererName !== 'Horizontal Stacked Bar Chart' ? rowKey : colKey;
            let tempColKey = this.config.rendererName !== 'Horizontal Bar Chart' &&
                this.config.rendererName !== 'Horizontal Stacked Bar Chart' ? colKey : rowKey;

            flatRowKey = tempRowKey.join(String.fromCharCode(765));
            flatColKey = tempColKey.join(String.fromCharCode(765));
            // var arrayOfRowKeys = this.flatRowKeys[0].split(' ');
            // var arrayOfColKeys = this.flatColKeys[0].split(' ');
            this.allTotal.push(record);

            if (tempRowKey.length !== 0) {
                if (!this.rowTotals[flatRowKey]) {
                    this.rowKeys.push(tempRowKey);
                    this.rowTotals[flatRowKey] = this.aggregator(this, tempRowKey, []);
                }
                this.rowTotals[flatRowKey].push(record);
            }
            if (tempColKey.length !== 0) {
                if (!this.colTotals[flatColKey]) {
                    this.colKeys.push(tempColKey);
                    this.colTotals[flatColKey] = this.aggregator(this, [], tempColKey);
                }
                this.colTotals[flatColKey].push(record);
            }
            if (tempColKey.length !== 0 && tempRowKey.length !== 0) {
                if (!this.tree[flatRowKey]) {
                    this.tree[flatRowKey] = {};
                }
                if (!this.tree[flatRowKey][flatColKey]) {
                    this.tree[flatRowKey][flatColKey] = this.aggregator(this, tempRowKey, tempColKey);
                }
                this.tree[flatRowKey][flatColKey].push(record);
            }

            if (tempColKey.length !== 0 && tempRowKey.length === 0) {
                if (!this.tree[flatColKey]) {
                    this.tree[flatColKey] = this.aggregator(this, tempColKey, []);
                }
                this.tree[flatColKey].push(record);
            }

            if (tempColKey.length === 0 && tempRowKey.length !== 0) {
                if (!this.tree[flatRowKey]) {
                    this.tree[flatRowKey] = this.aggregator(this, tempRowKey, []);
                }
                this.tree[flatRowKey].push(record);
            }
        })
        this.setMinMaxValues()
    }

    setRowValuesArray() {
        return {
            values: [],
            push: function (record) {
                var ref, ref1, ref2, x;
                x = record[attr];
                x = parseFloat(x);
                if (!isNaN(x)) {
                    this.values.push
                }
            },
            value: function () {
                return this.val;
            }
        };
    }

    setMinMaxValues() {
        var arrayOfValues = []

        for (var j = 0; j < this.flatRowKeys.length; j++) {
            if (!this.rowValues[this.flatRowKeys[j]]) {
                this.rowValues[this.flatRowKeys[j]] = [];
            }
            for (var i = 0; i < this.flatColKeys.length; i++) {
                if (!this.colValues[this.flatColKeys[i]]) {
                    this.colValues[this.flatColKeys[i]] = [];
                }

                if (this.tree[this.flatRowKeys[j]] !== undefined)
                    if (this.tree[this.flatRowKeys[j]][this.flatColKeys[i]]) {
                        var value = this.tree[this.flatRowKeys[j]][this.flatColKeys[i]].value();

                        if (!Number.isNaN(value)) {
                            arrayOfValues.push(value)
                            this.rowValues[this.flatRowKeys[j]].push(value)
                            this.colValues[this.flatColKeys[i]].push(value)
                        }
                    }
            }
        }


        // Get min max for full table
        this.minValue = Math.min(...arrayOfValues)
        this.maxValue = Math.max(...arrayOfValues)

        this.rowMinValues = {};
        this.rowMaxValues = {};
        this.colMinValues = {};
        this.colMaxValues = {};

        //Get min max per row/collumn
        if (Object.keys(this.rowValues).length !== 0) {
            for (var j = 0; j < this.flatRowKeys.length; j++) {
                if (!this.rowMinValues[this.flatRowKeys[j]]) {
                    this.rowMinValues[this.flatRowKeys[j]] = Math.min(...this.rowValues[this.flatRowKeys[j]]);
                }
                if (!this.rowMaxValues[this.flatRowKeys[j]]) {
                    this.rowMaxValues[this.flatRowKeys[j]] = Math.max(...this.rowValues[this.flatRowKeys[j]]);
                }
            }
        }

        if (Object.keys(this.colValues).length !== 0) {
            for (var j = 0; j < this.flatColKeys.length; j++) {
                if (!this.colMinValues[this.flatColKeys[j]]) {
                    this.colMinValues[this.flatColKeys[j]] = Math.min(...this.colValues[this.flatColKeys[j]]);
                }
                if (!this.colMaxValues[this.flatColKeys[j]]) {
                    this.colMaxValues[this.flatColKeys[j]] = Math.max(...this.colValues[this.flatColKeys[j]]);
                }
            }
        }

    }

    generateBody(tableBody) {
        const bodyTr = tableBody.getElementsByTagName("tr");
        this.currentRow = 0;
        var arrayOfValues = []
        for (var j = 0; j < this.flatRowKeys.length; j++) {
            for (var i = 0; i < this.flatColKeys.length; i++) {
                // var arrayOfRowKeys = this.flatRowKeys[j].split(' ');
                // var arrayOfColKeys = this.flatColKeys[i].split(' ');
                var cell = bodyTr[this.currentRow].insertCell(-1);
                cell.setAttribute('class', 'body-content');
                if (this.tree[this.flatRowKeys[j]][this.flatColKeys[i]]) {
                    var value = this.tree[this.flatRowKeys[j]][this.flatColKeys[i]].value()
                    if (this.config.vals[0]) {
                        cell.innerHTML = this.formatTableValue(value, this.tags.filter(tag => tag.key === this.config.vals[0])[0].type) + this.addInvisibleValueDiv(value);
                    } else {
                        cell.innerHTML = value + this.addInvisibleValueDiv(value);
                    }
                    //HEATMAP
                    if (this.reportConfig.rendererName === 'Heatmap') {
                        this.applyHeatmap(cell, value, 'full');
                    }
                    if (this.reportConfig.rendererName === 'Row Heatmap') {
                        this.applyHeatmap(cell, value, 'row', this.flatRowKeys[j]);
                    }
                    if (this.reportConfig.rendererName === 'Col Heatmap') {
                        this.applyHeatmap(cell, value, 'col', this.flatColKeys[i]);
                    }
                    if (this.reportConfig.rendererName === 'Table Barchart') {
                        this.applyTableBarChart(cell, value);
                    }
                } else {
                    cell.innerHTML = ''
                }
            }
            // Add totals row values
            if (this.totalsColumn) {
                var cell = bodyTr[this.currentRow].insertCell(-1);
                cell.setAttribute('class', 'totals-cell');
                if (this.config.vals[0]) {
                    cell.innerHTML = this.formatTableValue(this.rowTotals[this.flatRowKeys[j]].value(), this.tags.filter(tag => tag.key === this.config.vals[0])[0].type) + this.addInvisibleValueDiv(this.rowTotals[this.flatRowKeys[j]].value())
                } else {
                    cell.innerHTML = this.rowTotals[this.flatRowKeys[j]].value() + this.addInvisibleValueDiv(this.rowTotals[this.flatRowKeys[j]].value())
                }
            }
            this.currentRow++;
        }
    }

    addInvisibleValueDiv(value) {
        return "<div style='display:none'>" + (value === 'null' ? '' : value) + "</div>"
    }

    applyHeatmap(cell, value, type, flatKey) {
        switch (type) {
            case 'row':
                var opacityPercentage = (value - this.rowMinValues[flatKey]) / (this.rowMaxValues[flatKey] - this.rowMinValues[flatKey]) * 90 + 5;
                break;
            case 'col':
                var opacityPercentage = (value - this.colMinValues[flatKey]) / (this.colMaxValues[flatKey] - this.colMinValues[flatKey]) * 90 + 5;
                break;
            default:
                var opacityPercentage = (value - this.minValue) / (this.maxValue - this.minValue) * 90 + 5;
                break;
        }
        if (opacityPercentage > 50) {
            cell.setAttribute('style', `background:rgba(117, 48, 240, ${(parseFloat(opacityPercentage) / 100.0).toFixed(3)}) !important; color: white`)
        } else {
            cell.setAttribute('style', `background:rgba(117, 48, 240, ${(parseFloat(opacityPercentage) / 100.0).toFixed(3)}) !important`)
        }
    }

    applyTableBarChart(cell, value) {
        var opacityPercentage = (value - this.minValue) / (this.maxValue - this.minValue) * 100
        if (opacityPercentage > 50) {
            cell.setAttribute('style', `background: -webkit-linear-gradient(bottom, rgba(117, 48, 240) ${opacityPercentage}%, white ${opacityPercentage}%); 
            background: -ms-linear-gradient(bottom, rgba(117, 48, 240, 1) 0%, rgba(117, 48, 240, 1) ${opacityPercentage}%, white ${opacityPercentage}%);
            white 100%; color:white`)

        } else {
            cell.setAttribute('style', `background: -webkit-linear-gradient(bottom, rgba(117, 48, 240) ${opacityPercentage}%, white ${opacityPercentage}%); 
            background: -ms-linear-gradient(bottom, rgba(117, 48, 240, 1) 0%, rgba(117, 48, 240, 1) ${opacityPercentage}%, white ${opacityPercentage}%);
            white 100%`)

        }
    }

    generateTotals(is3Dtable) {

        var firstHeaderRow = this.table.getElementsByTagName("tr")[0];
        // Add totals column header
        var headerCell = document.createElement('TH');
        headerCell.innerHTML = 'Total';
        headerCell.setAttribute('rowSpan', this.xAxisCount + 1)
        headerCell.setAttribute('class', 'totals-header sortableCtx')
        headerCell.setAttribute('title', 'Total');
        firstHeaderRow.appendChild(headerCell)

        //Add totals footer
        if (this.totalsColumn) {
            var row = this.footer.insertRow(-1);
            var totalsCell = document.createElement('TD');

            totalsCell.setAttribute('colSpan', is3Dtable ? this.yAxisCount + 1 : this.yAxisCount)
            totalsCell.setAttribute('class', 'totals-footer-blank')
            row.appendChild(totalsCell)

            if (this.colTotals) {
                const colTotalsSorted = {}
                var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

                Object.keys(this.colTotals).sort(collator.compare).forEach((key) => {
                    colTotalsSorted[key] = this.colTotals[key];
                });

                Object.keys(colTotalsSorted).forEach((columnTotal) => {
                    var totalsCell = document.createElement('TD');
                    totalsCell.setAttribute('class', 'totals-footer-number');
                    if (this.config.vals[0]) {
                        totalsCell.innerHTML = this.formatTableValue(this.colTotals[columnTotal].value(), this.tags.filter(tag => tag.key === this.config.vals[0])[0].type);
                    } else {
                        totalsCell.innerHTML = this.colTotals[columnTotal].value()
                    }
                    row.appendChild(totalsCell);
                });
            }

            var totalsCell = document.createElement('TD');
            totalsCell.setAttribute('class', 'totals-footer-number')
            if (this.config.vals[0]) {
                totalsCell.innerHTML = this.formatTableValue(this.allTotal.value(), this.tags.filter(tag => tag.key === this.config.vals[0])[0].type);
            } else {
                totalsCell.innerHTML = this.allTotal.value();
            }
            row.appendChild(totalsCell)
        }
    }

    setCellContent(cell, value, index) {
        cell.innerHTML = this.formatTableValue(value, this.config.rows[index]) + this.addInvisibleValueDiv(value);
        //set custom classes based on value
        if (this.yAxis[index] === 'Instance compliancy') {
            switch (value) {
                case 'GREEN':
                    //add invisible font size 0 text for sorting purposes
                    cell.setAttribute('style', 'font-size:0px; text-align:center;');
                    cell.setAttribute('title', 'COMPLIANT');
                    //create container with icon
                    var iconNode = document.createElement("I");
                    iconNode.setAttribute('class', 'icon icon-okay status-green');
                    cell.appendChild(iconNode);
                    break;
                case 'GREY':
                    cell.textContent = value;
                    cell.setAttribute('style', 'font-size:0px; text-align:center;');
                    cell.setAttribute('title', 'UNDEFINED');
                    var iconNode = document.createElement("I");
                    iconNode.setAttribute('class', 'icon icon-undefined status-grey')
                    cell.appendChild(iconNode);
                    break;
                case 'RED':
                    cell.textContent = value;
                    cell.setAttribute('style', 'font-size:0px; text-align:center;');
                    cell.setAttribute('title', 'UNCOMPLIANT');
                    var iconNode = document.createElement("I");
                    iconNode.setAttribute('class', 'icon icon-fail status-red')
                    cell.appendChild(iconNode);
                    break;
            }
        } else {
            cell.setAttribute('title', this.formatTableValue(value, this.config.rows));
        }
    }

    sortTableClick(e) {
        this.busy = true;
        this.$timeout(() => {
            if ($('.pivotTable thead th .caret').length === 0) {
                $('.pivotTable thead th').append('<span class="caret"></span>');
            }
            let sortOrder = e.currentTarget.classList.contains('desc') ? 'asc' : 'desc';
            $('.pivotTable thead th').removeClass('sort');
            $('.pivotTable thead th').removeClass('desc');
            $('.pivotTable thead th').removeClass('asc');
            e.currentTarget.classList.add('sort');
            e.currentTarget.classList.add(sortOrder);
            const parentIndex = e.currentTarget.parentNode.rowIndex;
            const rootChildCount = e.currentTarget.parentNode.parentNode.childElementCount;
            const cellIndex = parentIndex === rootChildCount - 1
                ? e.currentTarget.cellIndex
                : e.currentTarget.cellIndex + this.yAxisCount - 1 - (this.xAxisCount === 1 ? 1 : 0);
            this.sortTable(sortOrder === 'desc' ? 1 : -1, cellIndex, e.currentTarget.textContent);
        }, 500);
    }

    sortTable(side, index, column) {
        let rows = $('.pivotTable tbody  tr').get();
        let totalRow = [];
        // if (this.hideTotalsArray.indexOf(this.config.aggregatorName) === -1) {
        //     totalRow = rows[rows.length - 1];
        //     rows.splice(-1, 1);
        // }

        let tempElem = [];
        let tempIndex = [];

        for (let k = 0; k < rows.length; k++) {
            for (let j = tempElem.length - 1; j >= 0; j--) {
                $(rows[k]).prepend(tempElem[j].clone());
                tempIndex[j]--;
                if (tempIndex[j] === 1) {
                    tempElem.splice(j, 1);
                    tempIndex.splice(j, 1);
                }
            }
            for (let i = 0; i < $(rows[k]).children('th').length; i++) {
                if (Number($(rows[k]).children('th').eq(i).attr('rowspan')) > 1) {
                    tempIndex.push(Number($(rows[k]).children('th').eq(i).attr('rowspan')));
                    $(rows[k]).children('th').eq(i).attr('rowspan', 1);
                    tempElem.push($(rows[k]).children('th').eq(i));
                }
            }

        }

        rows.sort(function (a, b) {
            let A = getVal(a);
            let B = getVal(b);

            if (column === 'Compressed size' || column === 'Avg change rate') {
                if (A < B) {
                    return -1 * side;
                }
                if (A > B) {
                    return 1 * side;
                }
                return 0;
            } else {
                A = A + '';
                B = B + '';
                return A.localeCompare(B, undefined, { numeric: true, sensitivity: 'base' }) * side;
            }
        });

        function getVal(elm) {
            let value = $(elm).children().eq(index).children().text().toUpperCase();
            // let numberRegex = /^(\d*\.*,*)*\d*$/g;
            // if ($.isNumeric(parseFloat(value)) && value.indexOf(':') < 1 && numberRegex.test(value)) {
            //     value = Number(value.replace(/[.,\s]/g, ''));
            // }
            return value;
        }

        for (let k = rows.length - 2; k >= 0; k--) {
            for (let i = 0; i < $(rows[k]).children('th').length; i++) {
                if ($(rows[k]).children('th').eq(i).text() === $(rows[k + 1]).children('th').eq(i).text()) {
                    $(rows[k]).children('th').eq(i).attr('rowspan', Number($(rows[k + 1]).children('th').eq(i).attr('rowspan')) + 1);

                }
                else {
                    for (let ii = i - 1; ii >= 0; ii--) {
                        $(rows[k + 1]).children('th').eq(ii).remove();
                    }
                    break;
                }
            }
        }

        $.each(rows, function (index, row) {
            $('.pivotTable').children('tbody').append(row);
        });

        // if (this.hideTotalsArray.indexOf(this.config.aggregatorName) === -1) {
        //     $('.pivotTable').children('tbody').append(totalRow);
        // }

        this.busy = false;
    }
}

const pivotTableComponent = {
    controller: PivotTableController,
    template: template,
    bindings: {
        report: '<',
        config: '=',
        tags: '<',
        data: '<',
        view: '=?',
        busyReport: '<',
        export: '<',
        filteringMode: '<'
    }
};

PivotTableController.$inject = ['$element', '$scope', '$filter', '$q', '$timeout', '$compile', 'utilsService', 'config'];

module.exports = pivotTableComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxPivotTable/ctxPivotTable.component.js